import React from 'react';
import BorderButton from './ui/subtle-button';
import { TextDisperse } from './ui/text-disperse';

const Hero = () => {
  const handleGetInTouch = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="home" className="relative w-full h-screen min-h-[760px] flex items-center justify-center overflow-hidden">
      <div className="relative z-10 text-center px-4 flex flex-col items-center">
        <TextDisperse
          className="kiua-disperse text-white font-black uppercase leading-[0.88] tracking-[-0.02em] select-none"
        >
          KIUA
        </TextDisperse>

        <div className="mt-3 md:mt-5 text-white/95 text-base md:text-2xl tracking-[0.45em] font-light">
          M U S I C &nbsp; G R O U P
        </div>

        <div className="mt-12 flex justify-center">
          <BorderButton onClick={handleGetInTouch}>GET IN TOUCH</BorderButton>
        </div>
      </div>

      {/* vignette */}
      <div className="absolute inset-0 pointer-events-none" style={{ background: 'radial-gradient(ellipse at center, rgba(0,0,0,0) 40%, rgba(0,0,0,0.7) 100%)' }} />
    </section>
  );
};

export default Hero;
